import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-box system-edit" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "field field-auto-complete" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "case" }, "Case", -1)
const _hoisted_8 = { class: "field field-auto-complete" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "motherboard" }, "Motherboard", -1)
const _hoisted_10 = { class: "field field-auto-complete" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "motherboard" }, "Power Supply", -1)
const _hoisted_12 = { class: "field field-auto-complete" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "cpu" }, "CPU", -1)
const _hoisted_14 = { class: "field field-auto-complete" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "cpucooler" }, "CPU Cooler", -1)
const _hoisted_16 = { class: "field field-auto-complete" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "memory" }, "Memory", -1)
const _hoisted_18 = { class: "field field-auto-complete" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "gpu" }, "GPU", -1)
const _hoisted_20 = { class: "field field-auto-complete" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "monitor" }, "Monitor", -1)
const _hoisted_22 = { class: "field field-auto-complete" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "other" }, "Other", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-plus" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "buttons" }
const _hoisted_27 = ["textContent"]

import { computed, onMounted, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { defaultSystem, System } from '@/models/system.model';
import { Actions } from '@/store';
import { HardwareComponent, TypeLabel } from '@/models/hardware.model';
import AutoComplete from '../auto-complete/AutoComplete.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SystemEdit',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const item = computed<System>(() => store.state.system);

const system = reactive<System>(new System(item.value || defaultSystem));

const isEdit = ref<boolean>(false);

const action = computed<string>(() => {
  return isEdit.value ? 'Edit' : 'Add';
});
const componentOptions = computed<TypeLabel[]>(
  () =>
    store.state.hardwareComponents?.map((c: HardwareComponent) => ({
      label: `${c.brand} ${c.name}`,
      value: c.id,
    })) || [],
);

onMounted(() => {
  store.dispatch(Actions.GetHardwareComponents);

  if (~route.path.indexOf('edit')) {
    // on reload
    isEdit.value = true;
    store.dispatch(Actions.GetSystemByName, route.params.slug).then((h) => {
      Object.assign(system, h);
    });
  } else {
    // get all ssytems first, so that adding a system works correctly
    store.dispatch(Actions.GetSystems);
    Object.assign(system, defaultSystem);
  }
});
const addOther = () => {
  system.otherComponents = [...system.otherComponents, -1];
};

const cancel = () => {
  store.commit('SetViewItem', null);
  router.push(`/system/${system.slug}`);
};

const submit = async () => {
  if (system.isValid()) {
    const response = await store.dispatch(Actions.UpdateSystem, {
      item: system,
      edit: isEdit.value,
    });
    if (response.status) {
      cancel();
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    system
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _createElementVNode("h2", null, _toDisplayString(system.name), 1),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              name: "name",
              autofocus: "",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((system.name) = $event))
            }, null, 512), [
              [_vModelText, system.name]
            ]),
            (!system.isValid('name'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(system.validation.messages.name)
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(AutoComplete, {
              id: "case",
              modelValue: system.case,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((system.case) = $event)),
              items: _unref(componentOptions)
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(AutoComplete, {
              id: "motherboard",
              modelValue: system.motherboard,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((system.motherboard) = $event)),
              items: _unref(componentOptions)
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(AutoComplete, {
              id: "motherboard",
              modelValue: system.powersupply,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((system.powersupply) = $event)),
              items: _unref(componentOptions)
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(AutoComplete, {
              id: "cpu",
              modelValue: system.cpu,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((system.cpu) = $event)),
              items: _unref(componentOptions)
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(AutoComplete, {
              id: "cpucooler",
              modelValue: system.cpucooler,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((system.cpucooler) = $event)),
              items: _unref(componentOptions)
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(AutoComplete, {
              id: "memory",
              modelValue: system.memory,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((system.memory) = $event)),
              items: _unref(componentOptions)
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(AutoComplete, {
              id: "gpu",
              modelValue: system.gpu,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((system.gpu) = $event)),
              items: _unref(componentOptions)
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(AutoComplete, {
              id: "monitor",
              modelValue: system.monitor,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((system.monitor) = $event)),
              items: _unref(componentOptions)
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(system.otherComponents, (c, i) => {
                return (_openBlock(), _createElementBlock("li", { key: c }, [
                  _createVNode(AutoComplete, {
                    id: "other",
                    modelValue: system.otherComponents[i],
                    "onUpdate:modelValue": ($event: any) => ((system.otherComponents[i]) = $event),
                    items: _unref(componentOptions)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                ]))
              }), 128))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "icon-only",
              onClick: addOther
            }, _hoisted_25)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "cancel",
              onClick: cancel
            }, "Cancel"),
            _createElementVNode("button", {
              type: "submit",
              textContent: _toDisplayString(_unref(action))
            }, null, 8, _hoisted_27)
          ])
        ], 40, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})